/// <reference path="../../typings/tsd.d.ts" /> 
module Elp.Api {
    export class GisDatastore {
        public static getFeatures(gisDatastoreId: string,
            boundingBox: Wars.Domain.Model.Execution.Entities.BoundingBox): angular.IPromise<any[]> {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');
            const $q: angular.IQService = angular.element(document.body).injector().get('$q');

            let d = $q.defer();

            $http.post('./api/GisDatastore/' + gisDatastoreId + '/GetFeatures', boundingBox).then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

        public static saveFeature(feature: any) {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');

            $http.post('./api/GisDatastore/SaveFeature', feature).then(r => {
            });
        }

        public static removeFeature(feature: any) {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');

            $http.post('./api/GisDatastore/RemoveFeature', feature).then(r => {
            });
        }

        public static getNewFeature(gisDatastoreId: string,
            processId?: string,
            geometryType?: Wars.Domain.Model.Codes.Enums.GeometryType,
            coordinates?: any): angular.IPromise<any> {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');
            const $q: angular.IQService = angular.element(document.body).injector().get('$q');

            let feature = {
                id: Services.UtilityService.generateGuidComb(),
                process_id: processId,
                gisDataStoreId: gisDatastoreId,
                geoJson: null
            };

            if (geometryType && coordinates) {
                feature.geoJson = JSON.stringify(this.createGeoJson(geometryType, coordinates));
            }

            let d = $q.defer();
            $http.post('./api/GisDatastore/AddFeature/' + gisDatastoreId, feature).then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

        public static createFeatureFromGeoJson(gisDatastoreId: string, geoJson: any):any {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');
            const $q: angular.IQService = angular.element(document.body).injector().get('$q');

            return {
                id: Services.UtilityService.generateGuidComb(),
                gisDataStoreId: gisDatastoreId,
                geoJson: geoJson
            };
        }

        public static saveFeatures(gisDatastoreId: string, features: Array<any>): angular.IPromise<any> {
            const $http: angular.IHttpService = angular.element(document.body).injector().get('$http');
            const $q: angular.IQService = angular.element(document.body).injector().get('$q');

            let d = $q.defer();
            var data = {
                features: features
            };

            console.log(data);

            $http.post(
                './api/GisDatastore/AddFeatures/' +
                gisDatastoreId,
                data).then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

        public static createGeoJson(geometryType: Wars.Domain.Model.Codes.Enums.GeometryType, coordinates: any) {
            return {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "type": geometryType,
                    "coordinates": coordinates
                }
            };
        }
    }
}